<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado
        :elementos="encabezado"
        :nameRoute="nameRoute"
        :paramsRoute="paramsRoute"
        :disabledButton="disabledHeader"
      />
      <v-card :class="[list.length < 6 ? 'calendar' : '']">
        <v-card-text>
          <div name="table">
            <v-data-table
              dense
              item-key="idStudy"
              :headers="headers"
              :items="list"
              :search="search"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                'items-per-page-all-text': 'Todo',
              }"
              no-results-text="Sin resultados coincidentes con la búsqueda"
              loading-text="Cargando..."
              no-data-text="Sin resultados disponibles"
              calculate-widths
              fixed-header
              height="auto"
              v-model="selected"
              :single-select="false"
              :show-select="true"
            >
              <template v-slot:top>
                <v-row align="baseline" justify="center" class="row">
                  <branch-offices-list
                    :classOfDiv="cols"
                    v-on:triggerChange="branchOfficeSelected"
                    :model="idBranchOfficeSelected"
                  />
                  <v-col cols="12" md="2" xl="2" sm="12">
                    <v-autocomplete
                      v-model="modalitiesSelect"
                      :items="modalities"
                      item-text="name"
                      item-value="idModality"
                      auto-select-first
                      clearable
                      label="Modalidad"
                      @change="listAll()"
                      no-data-text="Sin resultados disponibles"
                    />
                  </v-col>
                  <v-col cols="12" md="2" xl="2" sm="12">
                    <div class="text-right" id="handCalendar">
                      <vc-date-picker
                        color="gray"
                        v-model="date"
                        :max-date="new Date()"
                        is-range
                      >
                        <template v-slot="{ inputEvents }">
                          <div class="flex justify-center items-center">
                            <v-text-field
                              v-on="inputEvents.start"
                              :value="dateCompuded"
                              label="Fecha de interpretación..."
                              :append-icon="
                                validData ? 'mdi-eraser' : 'mdi-calendar'
                              "
                              @click:append="clearCalendar"
                              :disabled-input="validData"
                            ></v-text-field>
                          </div>
                        </template>
                      </vc-date-picker>
                    </div>
                  </v-col>
                  <!-- <div class="col-md-2 col-xl-2 col-sm-12" v-if="viewBirads">
                    <v-autocomplete
                      v-model="modelBirads"
                      no-data-text="Sin resultados"
                      @change="filterByBirads"
                      :items="listBirads"
                      label="Seleccionar BI-RADS"
                      clearable
                      append-icon="mdi-radioactive"
                    />
                  </div> -->
                  <v-col class="col">
                    <v-text-field
                      v-model="search"
                      label="Buscar"
                      class="pl-1"
                      :append-icon="search ? 'mdi-eraser' : 'mdi-magnify'"
                      @click:append="search = ''"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" xl="2" sm="12">
                    <v-tooltip top>
                      <span>Descargar Estudios</span>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          block
                          @click="checkDownload()"
                          :disabled="selected.length == 0 || sending"
                        >
                          <v-icon left> mdi-download </v-icon>
                          {{
                            sending ? "Descargando..." : "Descargar Estudios"
                          }}
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>

              <template v-slot:[`item.biradText`]="{ item }">
                <v-chip :color="item.colorBirad">
                  {{ item.biradText }}
                </v-chip>
              </template>
              <!-- <template v-slot:[`item.registrationDateInterpretation`]="{ item }">
                <small> {{item.registrationDateInterpretation}}</small>
              </template>
              <template v-slot:[`item.registrationDateStudy`]="{ item }">
                <small> {{item.registrationDateStudy}}</small>
              </template> -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="
                        changeViewInterpretation(item);
                        item.menu = false;
                      "
                      :disabled="sending"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="secondary">
                        mdi-information-variant
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Ver interpretación</span>
                </v-tooltip>

                <v-menu offset-y :nudge-width="200">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...menu }"
                        >
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <span>Más opciones</span>
                    </v-tooltip>
                  </template>

                  <v-list dense>
                    <v-list-item link @click="downloadInterpretation(item)">
                      <v-list-item-icon>
                        <v-icon color="error"> mdi-file-pdf-box </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Descargar PDF</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item link @click="changeViewUpdate(item)">
                      <v-list-item-icon>
                        <v-icon color="warning"> mdi-pencil </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item link @click="downloadZIP(item)">
                      <v-list-item-icon>
                        <v-icon color="secondary"> mdi-folder-download </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Descargar DICOM</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                      link
                      @click="changeViewAddendums(item)"
                      :disabled="sending"
                    >
                      <v-list-item-icon>
                        <v-icon color="cyan"> mdi-file-image </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          Visualizar archivos anexos
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <!-- <v-list-item
                      link
                      @click="viewHistory(item)"
                      :disabled="sending"
                    >
                      <v-list-item-icon>
                        <v-icon color="primary"> mdi-history</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          Visualizar historial de cambios
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item> -->
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
            <v-card-actions align="center">
              <v-col>
                <export-import-btn
                  texto="Exportar interpretaciones"
                  icono="export"
                  color="green darken-1"
                  v-if="false"
                  @accion="downloadReport()"
                />
              </v-col>
              <!--<v-col class="text-center">
              <export-import-btn
                texto="Exportar pacientes"
                icono="export"
                color="green darken-1"
                @accion="exportBranchOffice()"
              />
            </v-col>-->
            </v-card-actions>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h6 text-center success--text">
          ¿Desea descargar estos estudios?
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  <!-- <v-row>
                    <v-col
                      cols="1"
                      v-for="(item, index) in downloadList"
                      :key="index"
                    >
                      <span>{{ item }}</span>
                    </v-col>
                  </v-row> -->
                  <ul>
                    <li v-for="(item, index) in downloadList" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="text-center">
          <v-col>
            <v-btn color="error" plain @click="dialog = false">
              Cancelar <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              plain
              color="primary"
              :disabled="sending"
              @click="
                dialog = false;
                confirmDownload();
              "
            >
              Descargar estudios <v-icon right>mdi-download</v-icon>
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <loader :loader="sending" />
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false" :disabled="sending">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title id="inicio"
            >Cantidad de estudios a Descargar:
            {{ downloadList.length }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>ID's de Estudios a Descargar</v-subheader>

          
        </v-list>
        <v-divider></v-divider>
        <br />
        
        <div
          style="display: flex; justify-content: center; align-items: flex-end"
        >
          <v-col cols="2">
            <v-btn
              v-on="on"
              color="error"
              block
              @click="dialog = false"
              :disabled="sending"
            >
              <v-icon left> mdi-close </v-icon>
              {{ sending ? "Descargando..." : "Cancelar" }}
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
              v-on="on"
              color="primary"
              block
              @click="confirmDownload()"
              :disabled="sending"
            >
              <v-icon left> mdi-download </v-icon>
              {{ sending ? "Descargando..." : "Descargar Estudios" }}
            </v-btn>
          </v-col>
        </div>
        <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          right
          color="primary"
          @click="$vuetify.goTo('#inicio')"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
      </v-card>
    </v-dialog> -->
    <!-- end modals -->
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import moment from "moment";
import Datatable from "@/components/Datatable.vue";
import Sidebar from "@/components/Sidebar";
import {
  InterpretationHistoryRequest,
  BiradsRequest,
  StudyRequest,
  ReportPDFRequest,
  TemplateInterpretationRequest,
  DownloadZipRequest,
  SignRequest,
  InterpretationPendingRequest,
  ModaltyRequest,
} from "@/core/request";
import { UtilFront } from "@/core";
import { VueEditor } from "vue2-editor";
import { required, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import Loader from "../../components/Loader.vue";
import BranchOfficesList from "../../components/BranchOfficesList.vue";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";

setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "InterpretationPendingView",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    VueEditor,
    ValidationProvider,
    ValidationObserver,
    AutoLogout,
    Loader,
    BranchOfficesList,
    ExportImportBtn,
    ViewImageItem
  },
  computed: {
    dateCompuded() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return "";
      }

      return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
        this.date.end
      ).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return false;
      }
      this.listAll();
      return true;
    },
    nameRoute: function() {
      if (this.$utilFront.getRole() == "Médico interprete") {
        return "InterpretationPendingView1";
      }
      return;
    },
  },
  data: () => ({
    sending: false,
    selected: [],
    paramsRoute: {},
    actionModalities: 1,
    fab: false,
    disabledHeader: false,
    viewReport: false,
    actionOptions: 2,
    historial: [],
    acronym: "TD",
    date: "",
    dateModel: { startDate: "", endDate: "" },
    rangeDate: "",
    rangeDateText: "",
    action: 1,
    search: "",
    viewBirads: false,
    list: [],
    listFull: [],
    listBirads: [],
    interpretation: "",
    listTemplates: [],
    listTemplatesFull: [],
    listHistory: [],
    birads: {},
    speciality: "",
    model: { modality: { acronym: "TD", title: "Todas" } },
    encabezado: {
      icono: "mdi-download",
      texto: "Descarga de Estudios",
    },
    service: InterpretationHistoryRequest,
    headers: [
      { text: "Id Interpretación", value: "idInterpretation" },
      { text: "Id Estudio", value: "idStudy" },
      { text: "Nombre del paciente", value: "patient" },
      { text: "Modalidad", value: "modality" },
      { text: "Estudio", value: "studyModality" },
      { text: "BI-RADS", value: "biradText" },
      { text: "Fecha de interpretación", value: "interpretationDate" },
      { text: "Fecha de estudio", value: "registrationDate" },
      { text: "Nombre del intérprete", value: "interpreter", align: "center" },
    ],
    modelBirads: {},
    addendums: [],
    dialog: false,
    file: { bytes: "", fileName: "", type: "" },
    url: "",
    objectInterpretation: "",
    disabledButton: false,
    buttonBirads: false,
    withBirads: false,
    filesSign: undefined,
    files: [],
    invalidSign: true,
    typeDialog: null,
    modelDialog: {},
    menu: false,
    validBirads: true,
    imagesToAdd: [],
    images: [],
    filesToSave: [],
    filesToDelete: [],
    modelConfirmDeletion: false,
    mapping: [],
    reported: false,
    old: "",
    acon: "",
    disabledDownloadButton: false,
    idBranchOfficeSelected: null,
    cols: "col-md-2 col-xl-2 col-sm-12",
    dataHistory: {},
    modalities: [],
    modalitiesSelect: [],
    downloadList: [],
    sizeDownload: 0,
  }),
  created() {
    this.validBrowserTab();
    let speciality1 = localStorage.getItem("speciality");
    this.speciality = this.$route.params.speciality;
    if (this.speciality == undefined || this.speciality == "") {
      this.speciality = speciality1;
      if (this.$utilFront.isEmpty(speciality1)) {
        if (this.$route.path.includes("imagen")) {
          this.speciality = 2;
        } else if (this.$route.path.includes("laboratorio")) {
          this.speciality = 3;
        } else {
          this.speciality = 2;
        }
      }
    } else {
      localStorage.setItem("speciality", this.speciality);
    }
    this.listAllModalities();
    this.paramsRoute = this.$route.params;
    this.listAll();
    this.listAllBirads();
  },

  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError(e) {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno.", "ERROR");
    },
    listAll() {
      this.selected = [];
      try {
        this.sending = true;
        this.list = [];
        let aux = null;
        let acro = "";

        if (
          this.$utilFront.nonEmptyList(this.modalities) &&
          this.$utilFront.nonEmpty(this.modalitiesSelect)
        ) {
          aux = Object.assign(
            this.modalities.find((x) => x.idModality === this.modalitiesSelect)
          );
          if (aux) {
            acro = aux.acronym;
          }
        }

        let data = {
          acronym: acro != "" ? acro : this.acronym,
          idBranchOffice:
            this.idBranchOfficeSelected != null
              ? this.idBranchOfficeSelected
              : this.$utilFront.getIdBranchOffice(),
          speciality: this.speciality,
          modalities: this.$utilFront.nonEmpty(this.modalitiesSelect)
            ? [this.modalitiesSelect]
            : null,
        };

        data = Object.assign(data, this.date);

        if (
          this.$utilFront.nonEmpty(data.start) &&
          this.$utilFront.nonEmpty(data.end)
        ) {
          data.start = this.$utilFront.startOfDay(data.start);
          data.end = this.$utilFront.endOfDay(data.end);
        }

        this.service
          .listAllInterpretedByModalityAndBranchOffice(data)
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              let listData = res.data.data.map((obj) => {
                obj.dateInterpretation = new Date(obj.interpretationDate);
                obj.registrationDate = moment(obj.registrationDate).format(
                  UtilFront.FORMAT_DATE_TIME
                );
                obj.interpretationDate = moment(obj.interpretationDate).format(
                  UtilFront.FORMAT_DATE_TIME
                );
                obj.biradText = obj.biradText ? obj.biradText : "NA";
                obj.idBirad = obj.idBirad ? obj.idBirad : 0;
                obj.colorBirad = obj.colorBirad ? obj.colorBirad : "nobirad";
                return obj;
              });
              this.list = listData;
              this.listFull = listData;
            } else if (code == 401) {
              this.unauthorized();
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },

    listAllBirads() {
      try {
        this.listBirads = [];
        BiradsRequest.listAll()
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && Array.isArray(data)) {
              this.listBirads = data.map((obj) => {
                return {
                  value: { idBirads: obj.idBirads },
                  text: obj.name,
                  idBirads: obj.idBirads,
                };
              });
            } else if (code == 401) {
              this.unauthorized();
            }
          })
          .catch(this.catchError)
          .finally(() => {});
      } catch (e) {
        this.catchError(e);
      }
    },

    clearCalendar() {
      this.date = "";
      this.listAll();
    },
    filterListDate() {
      try {
        if (this.date != null && this.date != undefined && this.date != "") {
          let dateStart = moment(new Date(this.date.start))
            .startOf("day")
            .toDate();
          let dateEnd = moment(new Date(this.date.end))
            .endOf("day")
            .toDate();
          this.list = this.listFull.filter((obj) => {
            return (
              obj.dateInterpretation >= dateStart &&
              obj.dateInterpretation <= dateEnd
            );
          });
        } else {
          this.list = this.listFull.map((obj) => {
            return obj;
          });
        }
      } catch (error) {
        this.list = this.listFull.map((obj) => {
          return obj;
        });
        this.catchError(error);
      }
    },
    filterByBirads() {
      try {
        if (
          this.modelBirads != null &&
          this.modelBirads != undefined &&
          this.modelBirads != ""
        ) {
          this.list = this.listFull.filter((obj) => {
            return this.modelBirads.idBirads == obj.idBirad;
          });
        } else {
          this.list = this.listFull.map((obj) => {
            return obj;
          });
        }
      } catch (error) {
        this.list = this.listFull.map((obj) => {
          return obj;
        });
        this.catchError(error);
      }
    },

    downloadZIP(item) {
      try {
        let data = { idStudy: item };
        DownloadZipRequest.downloadImagesDCM(data)
          .then((res) => {
            const url = URL.createObjectURL(
              new Blob([res.data], {
                type: "application/zip",
              })
            );
            this.sizeDownload = this.sizeDownload - 1;
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SUIM_" + item + ".zip");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(this.catchError)
          .finally(() => {});
      } catch (e) {
        this.catchError(e);
      }
    },

    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },

    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 400;
    },
    listAllModalities() {
      let post = {
        idSpeciality: this.speciality,
      };
      ModaltyRequest.listModaltyByHumanResourceAndSpecialty(post).then(
        (res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.modalities = res.data.data.map((modality) => {
              return {
                idModality: modality.idModality,
                name: modality.acronym + " - " + modality.name,
                speciality: modality.speciality || "--- Sin información ---",
                acronym: modality.acronym,
              };
            });
            // this.modalitiesSelect = res.data.data.map((modality) => {
            //   return {
            //     idModality: modality.idModality,
            //   };
            // });
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.modalities = [];
          }
        }
      );
    },
    checkDownload() {
      this.dialog = true;
      this.downloadList = this.selected.map((it) => {
        return it.idStudy;
      });
      // for (let property of this.downloadList) {
      //   console.log(property);
      // }
    },
    async confirmDownload() {
      this.openAQES();
      this.sending = true;
      for (let idStudy of this.downloadList) {
        let params = { idStudy: idStudy };
        let response = await DownloadZipRequest.downloadImagesDCM(params);
        let fileName = "SUIM_" + idStudy + ".zip";
        this.$utilFront.downloadZIP(response.data, fileName);
      }
      this.sending = false;
      this.$utilFront.notifications("Estudios descargados.", "SUCCESS");
    },
    openAQES() {
      window.location.href = "AQES:";
    },
  },
};
</script>
<style scoped>
input[type="checkbox"] {
  transform: scale(1.5);
  margin: 10px;
  cursor: pointer;
}
.c1 {
  filter: hue-rotate(240deg);
}
</style>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11px !important;
}
</style>
